import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiClient } from './client'
import { SessionApiErrorResponse, SessionApiResponse } from './session/response'

const namespace = 'session-api'

export class SessionApiService {
  constructor(
    private readonly apiClient: typeof ApiClient = ApiClient
  ) {}

  /**
   * セッションの新規作成
   */
  async new(context: CreateNewSessionContext): Promise<Either<SessionApiErrorResponse, SessionApiResponse>> {
    try {
      const response = await this.apiClient.post('/api/user/session/new', {
        is_hl_app: context.isHlApp,
      })

      log.debug({ service: `${namespace}/new`, response })

      return new Right(response.body.data)
    } catch (error) {
      log.error({ service: `${namespace}/new`, error })
      const response = (error as any).response

      return new Left(response
        ? SessionApiErrorResponse.fromResponse(response)
        : SessionApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))
      )
    }
  }

  /**
   * 現在のセッションの延長
   */
  async keepCurrent(viewedPath: string): Promise<Either<SessionApiErrorResponse, SessionApiResponse>> {
    try {
      const response = await this.apiClient.put('/api/user/session/current/keep', {
        viewed_path: viewedPath,
      })

      log.debug({ service: `${namespace}/keepCurrent`, response })

      return new Right(response.body.data)
    } catch (error) {
      log.error({ service: `${namespace}/keepCurrent`, error })
      const response = (error as any).response

      return new Left(response
        ? SessionApiErrorResponse.fromResponse(response)
        : SessionApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))
      )
    }
  }
}

export interface CreateNewSessionContext {
  isHlApp: boolean
}
